import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import * as types from 'data/securityInfo/securityInfo.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import { FormLayout } from 'components/FormLayout';
import FieldDesc from 'components/FieldDesc';
import SectionLabel from 'components/SectionLabel';

type Props = {
  template: FormTemplate,
  data: Partial<types.SecurityInfo>,
  onFieldUpdate?: (param: FieldUpdateHandlerParam) => void,
};

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean,
  getValues: () => types.SecurityInfo,
};

export const SECURITY_INFO_FORM_I18N_KEY = 'securityInfo.form';

export const SecurityInfoForm = forwardRef<Ref, Props>(({
  template,
  data,
  onFieldUpdate = () => null,
}: Props, ref) => {
  const mainRef = useRef<Form>(null);

  const customFieldComponentMap = {
    nameHint: FieldDesc,
    privateKey: SectionLabel,
    certificate: SectionLabel,
  };

  const isValid = (forceValidation = false, forceTouched = true) => {
    const isMainValid = mainRef.current?.isValid(forceValidation, forceTouched) ?? true;
    return isMainValid;
  };

  const getValues = () => {
    const {
      nameHint,
      ...values
    } = mainRef.current?.getValues();

    const formValues: types.SecurityInfo = {
      ...values,
    };

    return formValues;
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  return (
    <div data-testid="SecurityInfoForm">
      <FormLayout>
        <Form
          ref={mainRef}
          name={template.formId ?? template.key}
          defaults={data}
          fields={(template.main as FormTemplateSection).fields}
          layout={(template.main as FormTemplateSection).metadata.layout?.rows}
          fieldUpdateHandler={onFieldUpdate}
          customFieldComponentMap={customFieldComponentMap}
          i18nKeyPrefix={SECURITY_INFO_FORM_I18N_KEY}
        />
      </FormLayout>
    </div>
  );
});

export default SecurityInfoForm;
